import { create } from 'zustand';

export type MobileTab = 'connections' | 'query' | 'terminal' | 'logs' | 'more';

export interface MobileScreen {
  type: string;
  title: string;
  params: Record<string, unknown>;
}

interface MobileStore {
  activeTab: MobileTab;
  stacks: Record<MobileTab, MobileScreen[]>;

  setActiveTab: (tab: MobileTab) => void;
  pushScreen: (screen: MobileScreen) => void;
  popScreen: () => void;
  resetStack: () => void;
}

const defaultStacks: Record<MobileTab, MobileScreen[]> = {
  connections: [{ type: 'connection-list', title: 'Connections', params: {} }],
  query: [{ type: 'query-list', title: 'Queries', params: {} }],
  terminal: [{ type: 'terminal-list', title: 'Terminals', params: {} }],
  logs: [{ type: 'logs', title: 'Logs', params: {} }],
  more: [{ type: 'more', title: 'More', params: {} }],
};

export const useMobileStore = create<MobileStore>((set) => ({
  activeTab: 'connections',
  stacks: { ...defaultStacks },

  setActiveTab: (tab) => set({ activeTab: tab }),

  pushScreen: (screen) => set((s) => {
    const tab = s.activeTab;
    return {
      stacks: {
        ...s.stacks,
        [tab]: [...s.stacks[tab], screen],
      },
    };
  }),

  popScreen: () => set((s) => {
    const tab = s.activeTab;
    const stack = s.stacks[tab];
    if (stack.length <= 1) return s; // Don't pop the root screen
    return {
      stacks: {
        ...s.stacks,
        [tab]: stack.slice(0, -1),
      },
    };
  }),

  resetStack: () => set((s) => ({
    stacks: {
      ...s.stacks,
      [s.activeTab]: [defaultStacks[s.activeTab][0]],
    },
  })),
}));
